export class sortingObj {
    itemperpage: number = 20;
    currentPgNo: number = 1;
    shortcolumn: string = "name";
    shortType: string = 'asc';
}

export class functionpermission {
    casemanagercreate: boolean = true
    casemanagerupdate: boolean = true
    casemanagerdelete: boolean = true
}

export class WhereCondition {
    field: string = "name";
    value: string = "";
    operator: string = "startswith";
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
    matchCase: boolean = false;
}

export class GetCaseListBo {
    SearchColumn: string = "Name";
    SearchText: string = "";
    orderColumn: string = "Name";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    userId: string = "00000000-0000-0000-0000-000000000000";
    field: string = "Name";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
}

export class columnWidth {
    column: string = "";
    width: number = 0;
}

export class caseManagerList {
    id: string="00000000-0000-0000-0000-000000000000";
    name: string;
    state: string;
    street: string;
    zip: string;
    city: string;
    phone: string;
    fax: string;
    agencyId: string ="00000000-0000-0000-0000-000000000000";
    email: string;
    alternate_Fax: string;
    county: string;
    agencyPhoneNum : string;
}





// export class caseManagerList {
//     id: number;
//     agencyId: number | null;
//     name: string;
//     county: string;
//     phone: string;
//     fax: string;
//     alternate_Fax: string;
//     email: string = "";
//     zip: string;
//     city: string;
//     state: string;
//     street: string;
    
// }

export class searchfilterDetails {
    Filter_Telephone: string;
    Filter_Fax: string;
    Filter_Alternate_Fax: string;
    Filter_County: string;
    Filter_CaseManagerName:string;
}

// // export class sortingObj
// // {
// //     itemperpage : number =20;
// //     currentPgNo : number = 1;
// //     shortcolumn : string = "caseManagerName" ;
// //     shortType : string = 'asc';
// // }

// export class functionpermission 
// {
//   casemanagercreate:boolean=true;
//   casemanagerdelete:boolean=true;
//   casemanagerupdate:boolean=true;
// }

// export class WhereCondition {
//     field: string="name";
//     value: string="";
//     operator: string="startswith";
//     orderNo: number=1;
//     predicate: string="and";
//     type: string="string";
//     matchCase:boolean=false;
// }
// export class GetCaseListBo {
//     SearchColumn: string = "name";
//     SearchText: string = "";
//     orderColumn: string = "name";
//     orderType: string= "asc";
//     pageitem: number = 10;
//     currentpageno: number = 1;
//     userId:string = "00000000-0000-0000-0000-000000000000";
//     field: string = "name";
//     value: string = "";
//     matchCase: boolean = false;
//     operator: string = "startswith";
//     agencyId: string ="00000000-0000-0000-0000-000000000000";
//     type: string = "string";
// }
// export class columnWidth {
//     column: string = "";
//     width: number = 0;
// }

export class ColumnChangeBO {
    id: number=0;
    userid: number=0;
    agencyId: number=0;
    column: string;
}